var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47208 13.357C2.41223 15.5691 4.19265 17.3172 6.42168 18.2167C8.6507 19.1161 11.1457 19.0933 13.3579 18.1531C15.5701 17.213 17.3182 15.4326 18.2176 13.2035C19.1171 10.9745 19.0942 8.47947 18.1541 6.2673C17.2139 4.05513 15.4335 2.30704 13.2045 1.40759C10.9754 0.508132 8.4804 0.530995 6.26824 1.47114C4.05607 2.41129 2.30798 4.19172 1.40852 6.42074C0.50907 8.64977 0.531933 11.1448 1.47208 13.357V13.357Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2209 16.22L23.2499 23.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSearch;